import 'react-datepicker/dist/react-datepicker.css';

import { Avatar, Card, Col, Input, Row, Select, Statistic, Table, Tag, Typography } from 'antd';
import DatePicker, { registerLocale } from 'react-datepicker';
import {
  FaArrowLeft,
  FaCalendarAlt,
  FaChartLine,
  FaDice,
  FaGamepad,
  FaHistory,
  FaMoneyBillWave,
  FaSearch,
  FaTimesCircle,
  FaTrophy,
  FaUser,
} from 'react-icons/fa';
import { useCallback, useEffect, useState } from 'react';

import { BetHistoryGrid } from '~/data/dummy';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { RangeDatePicker } from '~/components/common';
import axios from 'axios';
import { baseUrl } from '~/utils/helper';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useTableSearch } from '~/Hooks';
import { useTranslation } from 'react-i18next';
import vi from 'date-fns/locale/vi';
import { useStateContext } from '~/contexts/ContextProvider';

const { Search } = Input;
const { Text } = Typography;
registerLocale('vi', vi);

const BetHistory = ({ title }) => {
  const { formatMoney } = useStateContext();
  const { t } = useTranslation('report');
  const { state } = useLocation();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [dataUser, setDataUser] = useState([]);
  const [searchVal, setSearchVal] = useState(null);
  const [isLoad, setIsLoad] = useState(true);

  const [startDate, setStartDate] = useState(
    dayjs().add(-7, 'd').format('YYYY-MM-DD') + ' 00:00:00',
  );
  const [endDate, setEndDate] = useState(dayjs().format('YYYY-MM-DD') + ' 23:59:59');

  // Main category state
  const [mainCategory, setMainCategory] = useState('api');
  // Sub game state (only used when mainCategory is "minigame")
  const [subGame, setSubGame] = useState('sicbo');

  // Derived state for API calls
  const [loai, setLoai] = useState('api');

  document.title = title;

  // Update loai when category changes
  useEffect(() => {
    if (mainCategory === 'minigame') {
      setLoai(subGame);
    } else {
      setLoai(mainCategory);
    }
  }, [mainCategory, subGame]);

  useEffect(() => {
    axios
      .get(`${baseUrl}/api/daily/bet-history`, {
        params: {
          username: state.data.username,
          startDate: dayjs(startDate).format('YYYY-MM-DD') + ' 00:00:00',
          endDate: dayjs(endDate).format('YYYY-MM-DD') + ' 23:59:59',
          page,
          loai,
          type: 'all',
          providercode: 'all',
        },
        headers: {
          'x-access-token': sessionStorage.getItem('auth'),
          'Access-Control-Allow-Origin': '*',
        },
      })
      .then((res) => {
        const { success, data } = res.data;
        if (success) {
          setDataUser(data);
          setIsLoad(false);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('common:error'), { them: 'light' });
        setIsLoad(false);
      });
  }, [page, loai]);

  const handleSearch = () => {
    setIsLoad(true);
    console.log(`state.data : `, state.data);
    axios
      .get(`${baseUrl}/api/daily/bet-history`, {
        params: {
          username: state.data.username,
          startDate: dayjs(startDate).format('YYYY-MM-DD') + ' 00:00:00',
          endDate: dayjs(endDate).format('YYYY-MM-DD') + ' 23:59:59',
          page,
          loai,
          type: 'all',
          providercode: 'all',
        },
        headers: {
          'x-access-token': sessionStorage.getItem('auth'),
          'Access-Control-Allow-Origin': '*',
        },
      })
      .then((res) => {
        const { success, data } = res.data;
        if (success) {
          setDataUser(data);
          setIsLoad(false);
        }
      })
      .catch((err) => {
        toast.error(t('common:error'), { them: 'light' });
        setIsLoad(false);
      });
  };

  const handleChangeDate = (v) => {
    setStartDate(v[0]);
    setEndDate(v[1]);
  };

  const betHistory = BetHistoryGrid(loai);

  // Main category options
  const mainCategoryOptions = [
    {
      value: 'api',
      label: 'Game API',
      icon: '🎮',
      color: 'bg-gradient-to-r from-blue-500 to-purple-500',
    },
    {
      value: 'xoso',
      label: t('xoso'),
      icon: '🎱',
      color: 'bg-gradient-to-r from-green-500 to-emerald-500',
    },
    {
      value: 'minigame',
      label: 'Mini Game',
      icon: '🎲',
      color: 'bg-gradient-to-r from-yellow-500 to-orange-500',
    },
  ];

  // Mini game options (shown when mainCategory is "minigame")
  const miniGameOptions = [
    {
      value: 'sicbo',
      label: t('taixiu'),
      icon: '🎲',
      color: 'bg-gradient-to-r from-yellow-500 to-orange-500',
    },
    {
      value: 'xocdia',
      label: t('xocdia'),
      icon: '🔴',
      color: 'bg-gradient-to-r from-red-500 to-pink-500',
    },
    {
      value: 'baucua',
      label: t('baucua'),
      icon: '🦀',
      color: 'bg-gradient-to-r from-orange-500 to-red-500',
    },
    {
      value: 'quyetchien',
      label: t('quyetchien'),
      icon: '⚔️',
      color: 'bg-gradient-to-r from-slate-600 to-slate-800',
    },
    {
      value: 'rongho',
      label: t('rongho'),
      icon: '🐲',
      color: 'bg-gradient-to-r from-red-600 to-red-500',
    },
    {
      value: 'xocdia_blockchain',
      label: t('xocdia') + ' Blockchain',
      icon: '⛓️',
      color: 'bg-gradient-to-r from-purple-500 to-indigo-500',
    },
    {
      value: 'baccarat_blockchain',
      label: 'Baccarat Blockchain',
      icon: '♠️',
      color: 'bg-gradient-to-r from-cyan-500 to-blue-500',
    },
  ];

  const handleMainCategoryChange = (value) => {
    setMainCategory(value);
    setDataUser([]);
    // Reset sub game when changing main category
    if (value === 'minigame' && !subGame) {
      setSubGame('sicbo');
    }
  };

  const handleSubGameChange = (value) => {
    setSubGame(value);
    setDataUser([]);
  };

  // Get current game info for display
  const getCurrentGameInfo = () => {
    if (mainCategory === 'minigame') {
      return miniGameOptions.find((game) => game.value === subGame);
    }
    return mainCategoryOptions.find((game) => game.value === mainCategory);
  };

  const currentGame = getCurrentGameInfo();

  // Calculate statistics
  const calculateStats = () => {
    const data = dataUser?.data || [];
    const totalBets = data.length;
    const totalAmount = data.reduce((sum, bet) => sum + (parseFloat(bet.bet) || 0), 0);
    const totalWin = data.reduce((sum, bet) => sum + (parseFloat(bet.win) || 0), 0);
    const totalLoss = totalAmount - totalWin;

    return { totalBets, totalAmount, totalWin, totalLoss };
  };

  const { totalBets, totalAmount, totalWin, totalLoss } = calculateStats();

  return (
    <div className="min-h-screen p-2 md:p-6 bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
      {/* Header Section */}
      <div className="p-2 mb-4 border shadow-xl md:mb-8 md:p-6 rounded-2xl bg-white/90 backdrop-blur-2xl border-white/20">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          {/* Title & User Info */}
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center justify-center w-6 h-6 text-white transition-all duration-300 border-none shadow-lg md:w-12 md:h-12 rounded-xl bg-gradient-to-r from-blue-500 to-purple-600 hover:scale-105">
              <FaArrowLeft size={16} />
            </button>

            <div className="flex items-center gap-3">
              <Avatar
                size={48}
                className="font-bold text-white bg-gradient-to-r from-blue-500 to-purple-500">
                {state?.data?.username?.charAt(0)?.toUpperCase()}
              </Avatar>
              <div>
                <h1 className="mb-1 text-lg font-bold text-transparent md:text-2xl bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text">
                  <FaHistory className="inline mr-2 text-blue-500" />
                  {t('lich_su_cuoc')}
                </h1>
                <p className="flex items-center gap-2 text-gray-600">
                  <FaUser className="text-blue-500" size={14} />
                  {state?.data?.username}
                </p>
              </div>
            </div>
          </div>

          {/* Controls */}
          <div className="flex flex-col gap-4 lg:flex-row lg:items-end">
            {/* Date Range */}
            <div className="flex flex-col gap-2">
              <RangeDatePicker
                onChange={handleChangeDate}
                className="w-full h-12 border-2 rounded-xl border-blue-500/20 bg-white/90"
              />
            </div>

            {/* Main Category */}
            <div className="flex flex-col gap-2">
              <label className="flex items-center hidden gap-2 text-sm font-medium text-gray-700 md:flex">
                <FaGamepad className="text-purple-500" />
                {t('loaitrochoi')}
              </label>
              <Select
                value={mainCategory}
                onChange={handleMainCategoryChange}
                className="md:w-[220px] w-full [&_.ant-select-selector]:!rounded-xl [&_.ant-select-selector]:!h-12"
                size="large">
                {mainCategoryOptions.map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    <div className="flex items-center gap-2">
                      <span className="text-base">{option.icon}</span>
                      <span>{option.label}</span>
                    </div>
                  </Select.Option>
                ))}
              </Select>
            </div>

            {/* Sub Game Select (only shown when mainCategory is "minigame") */}
            {mainCategory === 'minigame' && (
              <div className="flex flex-col gap-2">
                <label className="flex items-center hidden gap-2 text-sm font-medium text-gray-700 md:flex">
                  <FaDice className="text-orange-500" />
                  {t('chon_game')}
                </label>
                <Select
                  value={subGame}
                  onChange={handleSubGameChange}
                  className="md:w-[220px] w-full [&_.ant-select-selector]:!rounded-xl [&_.ant-select-selector]:!h-12"
                  size="large">
                  {miniGameOptions.map((option) => (
                    <Select.Option key={option.value} value={option.value}>
                      <div className="flex items-center gap-2">
                        <span className="text-base">{option.icon}</span>
                        <span>{option.label}</span>
                      </div>
                    </Select.Option>
                  ))}
                </Select>
              </div>
            )}

            {/* Search Button */}
            <button
              onClick={handleSearch}
              className="flex items-center justify-center h-12 gap-2 px-6 py-3 font-semibold text-white transition-all duration-300 border-none shadow-lg rounded-xl bg-gradient-to-r from-blue-500 to-purple-600 hover:scale-105 hover:shadow-xl">
              <FaSearch size={16} />
              {t('common:search')}
            </button>
          </div>
        </div>
      </div>

      {/* Current Game Info */}
      <div className="flex items-center gap-3 p-4 mb-6 border rounded-xl bg-white/80 backdrop-blur-xl border-white/20">
        <div
          className={`w-12 h-12 rounded-lg flex items-center justify-center text-white text-xl font-bold ${currentGame?.color}`}>
          {currentGame?.icon}
        </div>
        <div>
          <h3 className="font-semibold text-gray-800">
            {t('dang_xem')}: {currentGame?.label}
          </h3>
          <p className="text-sm text-gray-600">
            {t('lich_su_cuoc_tu')} {dayjs(startDate).format('DD/MM/YYYY')} {t('den')}{' '}
            {dayjs(endDate).format('DD/MM/YYYY')}
          </p>
        </div>
      </div>

      {/* Statistics Cards */}
      <Row gutter={[16, 16]} className="mb-4 md:mb-8">
        <Col xs={12} sm={12} lg={12}>
          <Card className="text-center text-white transition-all duration-300 border-none bg-gradient-to-r from-green-500 to-emerald-600 rounded-2xl hover:scale-105">
            <Statistic
              title={
                <span className="flex items-center justify-center gap-2 text-white/90">
                  <FaMoneyBillWave /> {t('tong_cuoc')}
                </span>
              }
              value={totalAmount}
              formatter={(value) => formatMoney(value)}
              valueStyle={{
                color: 'white',
                fontWeight: 'bold',
                fontSize: '16px',
              }}
            />
          </Card>
        </Col>

        <Col xs={12} sm={12} lg={12}>
          <Card className="text-center text-white transition-all duration-300 border-none bg-gradient-to-r from-yellow-500 to-orange-600 rounded-2xl hover:scale-105">
            <Statistic
              title={
                <span className="flex items-center justify-center gap-2 text-white/90">
                  <FaTrophy /> {t('thang/thua')}
                </span>
              }
              value={totalWin - totalLoss}
              formatter={(value) => formatMoney(value)}
              valueStyle={{
                color: 'white',
                fontWeight: 'bold',
                fontSize: '16px',
              }}
            />
          </Card>
        </Col>
      </Row>

      {/* Data Table */}
      <div className="p-2 border shadow-xl md:p-6 rounded-2xl bg-white/90 backdrop-blur-2xl border-white/20">
        <div className="flex items-center justify-between mb-4">
          <h3 className="flex items-center gap-2 text-lg font-bold text-gray-800 md:text-xl">
            <FaChartLine className="text-blue-500" />
            {t('chi_tiet_lich_su_cuoc')}
          </h3>
          <Tag color="blue" className="px-3 py-1 text-sm font-medium rounded-lg">
            {dataUser?.total || 0} {t('ban_ghi')}
          </Tag>
        </div>

        <Table
          rowKey="id"
          dataSource={dataUser?.data}
          columns={betHistory}
          loading={isLoad}
          bordered={false}
          size="middle"
          className="overflow-hidden custom-bet-table rounded-xl"
          pagination={{
            total: dataUser?.total,
            current: page,
            pageSize: 50,
            showSizeChanger: false,
            showQuickJumper: true,
            showTotal: (total, range) => `${range[0]}-${range[1]} của ${total} bản ghi`,
            onChange: (newPage) => {
              setPage(newPage);
            },
            className: 'mt-6',
          }}
          scroll={{ x: 'max-content' }}
          rowClassName={(record, index) =>
            index % 2 === 0 ? 'bg-white hover:bg-blue-50' : 'bg-gray-50 hover:bg-blue-50'
          }
        />
      </div>

      <style jsx>{`
        .custom-bet-table .ant-table-thead > tr > th {
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
          border-bottom: 2px solid #e2e8f0 !important;
          font-weight: 600 !important;
          color: #374151 !important;
          padding: 16px !important;
          text-align: center !important;
        }

        .custom-bet-table .ant-table-tbody > tr > td {
          padding: 12px 16px !important;
          border-bottom: 1px solid #f1f5f9 !important;
          text-align: center !important;
        }

        .ant-pagination .ant-pagination-item {
          border-radius: 8px !important;
          border: 1px solid #e2e8f0 !important;
        }

        .ant-pagination .ant-pagination-item-active {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
          border-color: transparent !important;
        }

        .ant-pagination .ant-pagination-item-active a {
          color: white !important;
        }
      `}</style>
    </div>
  );
};

export default BetHistory;
